import { authLogout } from '@my-langguth/auth-ui'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { useNavigate } from '@tanstack/react-router'
import { toast } from 'sonner'

import { getMeOptions } from '@/client/@tanstack/react-query.gen'
import { CHECKLISTEN_AUTH_API_BASE } from '@/lib/checklisten-auth-api-base'

export function useAuth() {
  const queryClient = useQueryClient()
  const navigate = useNavigate()

  const { data: user, isLoading, error } = useQuery({
    ...getMeOptions(),
    retry: false,
  })

  const logoutMutation = useMutation({
    mutationFn: () => authLogout(CHECKLISTEN_AUTH_API_BASE),
    onSettled: () => {
      void queryClient.invalidateQueries({ queryKey: getMeOptions().queryKey })
      toast.success('Erfolgreich abgemeldet')
      void navigate({
        to: '/login',
        search: { redirect: undefined },
      })
    },
  })

  const logout = () => {
    logoutMutation.mutate()
  }

  return {
    user,
    isLoading,
    isAuthenticated: Boolean(user) && !error,
    isCustomerUser: user?.type === 'customer',
    isLangguthUser: user?.type === 'langguth',
    customerId: user?.customerId,
    logout,
    isLoggingOut: logoutMutation.isPending,
  }
}
